<form [formGroup]="customPhoneForm">
  <p-inputGroup styleClass=" flex bg-white border-1 border-300 border-round">
    <p-select [options]="countries" formControlName="country" appendTo="body"
      styleClass="w-7rem border-none shadow-none" optionLabel="name" (onChange)="onCountryChange($event)"
      [filter]="true" filterPlaceholder="Search countries..." [ngClass]="{'phone-dropdown': true}">

      <ng-template pTemplate="item" let-country>
        <div class="country-item">
          <span>{{ country.name }} ({{ country.dial_code }})</span>
        </div>
      </ng-template>

      <ng-template pTemplate="selectedItem" let-selectedCountry>
        <div class="country-item">
          <span>{{ selectedCountry.dial_code }}</span>
        </div>
      </ng-template>

      <ng-template pTemplate="empty">
        <div style="display: flex; justify-content: center; align-items: center; width: 200px;">
          <span>No results found</span>
        </div>
      </ng-template>
    </p-select>

    <input pInputText type="tel" formControlName="phoneNumber" class="border-none w-full shadow-none"
      id="PrimaryContactNumber"
      [placeholder]="customPlaceholder ? customPlaceholder : (isCustomer ? 'Contact Number' : 'Phone number')"
      (keypress)="validateNumber($event)" autocomplete="off" />
  </p-inputGroup>
  <ng-container
    *ngIf="customPhoneForm.get('phoneNumber')?.invalid && (customPhoneForm.get('phoneNumber')?.dirty || customPhoneForm.get('phoneNumber')?.touched)">
<small class="text-red-500" *ngIf="customPhoneForm.get('phoneNumber')?.errors?.['required']">
  {{ '*Phone number is required' }}
</small>
    <small class="text-red-500" *ngIf="customPhoneForm.get('phoneNumber')?.errors?.['pattern']">Invalid phone
      number</small>
  </ng-container>
</form>